import { render } from "./ProdutosIpiranga.vue?vue&type=template&id=41ca9b0b&scoped=true&ts=true"
import script from "./ProdutosIpiranga.vue?vue&type=script&lang=ts"
export * from "./ProdutosIpiranga.vue?vue&type=script&lang=ts"

import "./ProdutosIpiranga.vue?vue&type=style&index=0&id=41ca9b0b&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ca9b0b"]])

export default __exports__